import React, { useEffect, useState, useRef } from "react";
// import Carousel from "react-multi-carousel";
import Carousel from "nuka-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDataProvider } from "./DataProvider";
import { useCommProvider } from "./CommProvider";

import { LinearProgress } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Button } from "@material-ui/core";
import { pDataProvider } from "../utils/parameters";


import { formatGlossNormalizated } from "./utils/strings";


// const MAX_LOADING = 3;

export function VideoCarouselExamples(props) {
  const { dialogElements, dialogPosition, setDialogPosition, setSentence_selected } = props;
  const [repoVideos, setRepoVideos] = useState([]);

  const { json_data_meaning, json_data_glosses, json_data_sentence, comm_getPublicURLVideoData, comm_getPublicURLJSONData } = useDataProvider();
  const { comm_downloadFileFromUrl } = useCommProvider();
  const [initialSlide, setInitialSlide] = useState(0);

  // const [counterLoading, setCounterLoading] = useState(0);
  const [visible, setVisible] = useState(false); // False: Loading activo & display 'non' y viceversa.]
  const videoRefs = useRef([]);
  const firstLoad = useRef(true);
  const customPrevSlide = useRef(0); //MOB - This could be removed if we could modify the nextSlide and prevSlide functions of the plugin
  const customActualSlide = useRef(0);

  const overlayRef = useRef(null);

  useEffect(() => {
  
    async function buildRepoVideos() {

      let vids = [];
      

      if (dialogPosition["meaning"] !== undefined){
        let counter_idx = 0;
        const arr_glosses_total = [... json_data_meaning[dialogPosition["meaning"]][pDataProvider.arr_glosses], ...json_data_meaning[dialogPosition["meaning"]][pDataProvider.arr_variants]]

        arr_glosses_total.forEach( async (item_gloss, index) => {
          json_data_glosses[item_gloss][pDataProvider.arr_sentences].forEach( async (item_sentence_idx, index) => {
            let vid = {};
            vid["id"] = counter_idx;
            vid["_id"] = item_sentence_idx;
            vid["video"] = comm_getPublicURLVideoData(pDataProvider.dir_vid_sentence, item_sentence_idx);
            vid["json"] = comm_getPublicURLJSONData(pDataProvider.dir_json_sentence, item_sentence_idx);
            vid["gloss_id"] = item_gloss;
            vid["tintervals"] = [];
            vids.push(vid);
            counter_idx++;
          });

        });
        
        if (vids.length > pDataProvider.carousel_number_max_examples) {
          const shuffledArray = vids.sort(() => 0.5 - Math.random());
          vids =  shuffledArray.slice(0, pDataProvider.carousel_number_max_examples);
        }
        setRepoVideos(vids);
      }
      

      console.log("🚀 ~ buildRepoVideos ~ vids:", vids)

      if (vids.length > 0) {
        setSentence_selected(vids[0]["_id"])
      }

      firstLoad.current = true;

    }

    buildRepoVideos();


  }, []);

  useEffect(() => {

    repoVideos.forEach( async (item_vid, index) => {

      const json_data_response = await comm_downloadFileFromUrl(item_vid['json'])

      json_data_response.M_Glosa.annotations.forEach( (item_anns, index) => {

         if (formatGlossNormalizated(item_anns['value']) === formatGlossNormalizated(json_data_glosses[item_vid["gloss_id"]][pDataProvider.label])) {
          item_vid['tintervals'].push([(item_anns['start']/1000), (item_anns['end']/1000)])
         }
      });
    });
  }, [repoVideos])
    


  const beforeSlide = (currentSlideIndex, endSlideIndex) => {

    setSentence_selected(repoVideos[endSlideIndex]["_id"]);
    setDialogPosition({ ...dialogPosition, gloss: repoVideos[endSlideIndex]["gloss_id"] });

    customPrevSlide.current = currentSlideIndex;
  };

  const afterSlide = (index) => {
    videoRefs.current[customPrevSlide.current].currentTime = 0;
    videoRefs.current[customPrevSlide.current].pause();
    videoRefs.current[index].play();
    customActualSlide.current = index;
  };

  //MOB - Sometimes, the first video would not load properly. This should fix it.
  const loadVideo = () => {
    if (firstLoad.current === true && videoRefs.current[0].readyState === 4) {
      setVisible(true);
      videoRefs.current[initialSlide].play();
      firstLoad.current = false;
    }
  };

  //MOB - A little "dirty", but the carousel plugin inserts 3 slides for each video to allow infinite scroll, so this is needed to only play the desired videos - Check
  let refCloneOffset = 0;
  const setVideoRefs = (ref) => {
    if (refCloneOffset === repoVideos.length) {
      if (videoRefs.current.length < repoVideos.length) {
        videoRefs.current.push(ref);
      }
    } else {
      refCloneOffset++;
    }
  };


  const handleTimeUpdate = () => {

    const t_actual = videoRefs.current[customActualSlide.current].currentTime;

    const isInInterval = repoVideos[customActualSlide.current]["tintervals"].some(([t_start, t_end]) => {
      return t_start <= t_actual && t_actual <= t_end;
    });

    if (isInInterval){
      overlayRef.current.style.opacity = '0.4';
      overlayRef.current.style.height = '100%';
      videoRefs.current[customActualSlide.current].playbackRate = 0.5
    }else{
      overlayRef.current.style.opacity = '0';
      videoRefs.current[customActualSlide.current].playbackRate = 1
    }

  };

  return (
    <>
      {repoVideos[0] !== undefined ? (
        <>
          {visible === false && <LinearProgress color="primary" />}
          <Carousel
            className="sig_SignModal_VideoContainer sig_SignModal_CarouselContainer"
            wrapAround={true}
            slidesToShow={1}
            beforeSlide={beforeSlide}
            afterSlide={afterSlide}
            slideIndex={initialSlide}
            // disableAnimation = {true}
            speed={800}
            renderCenterLeftControls={({ previousDisabled, previousSlide }) =>
              (visible === true && repoVideos.length>1) ? (
                <Button className="sig_SignModal_CarouselPrev" onClick={previousSlide} disabled={previousDisabled}>
                  <NavigateBeforeIcon fontSize="large" color="primary" />
                </Button>
              ) : (
                <></>
              )
            }
            renderCenterRightControls={({ nextDisabled, nextSlide }) =>
            (visible === true && repoVideos.length>1) ? (
                <Button className="sig_SignModal_CarouselNext" onClick={nextSlide} disabled={nextDisabled}>
                  <NavigateNextIcon fontSize="large" color="primary" />
                </Button>
              ) : (
                <></>
              )
            }
            defaultControlsConfig={{
              pagingDotsClassName: "sig_SignModal_CarouselDots",
              pagingDotsStyle: { fill: "#5ea0d4" },
            }}
          >
            {repoVideos.map((videoObj, idx) => {
              return (
                <React.Fragment key={idx}>
                  <video key={`video-${idx}`}  ref={(v) => setVideoRefs(v)} className={`sig_SignModal_CarouselVideo ${visible ? "" : "sig_SignModal_CarouselVideoHidden"}`} 
                    controls 
                    disablePictureInPicture 
                    controlsList="nodownload"
                    loop 
                    muted 
                    src={videoObj.video} 
                    onCanPlayThrough={() => loadVideo()} 
                    onTimeUpdate={handleTimeUpdate}
                  />
                  <div key={`overlay-${idx}`} ref={overlayRef} className="sig_SignModal_VideoOverlay" />
                </React.Fragment>
              )
            })}
          </Carousel>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
export default VideoCarouselExamples;
